/**
 * 去往订单确认页的相关逻辑
 * 非订单确认页的业务
 */
import App from '@/main'

import queryString from 'query-string'
import jsCookie from 'js-cookie'
export * from '../customised-goods'

/**
 * 设置跳转至订单确认页的路由
 * @param {{spuId,parentSpuId,storeInfo,query,isCustomisedGoods}} param0
 */
export function setConfirmQuery({
  spuId,
  storeInfo,
  query,
  isCustomisedGoods = true
}) {
  let parentSpuId = spuId

  // 定制SKU商品 更换门店后，同步更新spuId, skuId
  if (isCustomisedGoods) {
    if (storeInfo) {
      // 门店模块已加载完毕
      const { spuId: _spuId, skuId, businessKey } = storeInfo
      spuId = _spuId
      Object.assign(query, {
        skuId,
        businessKey
      })
    } else {
      // 门店模块未加载完毕即跳转至订单提交页
      Object.assign(query, {
        beforeMLoaded: true
      })
    }
  }
  Object.assign(query, {
    parentSpuId,
    isCustomisedGoods
  })
  // query为引用类型
  return {
    spuId,
    query
  }
}

export function getCZJConfirmUrl(query) {
  //成长加订单确认页
  const queryStr = queryString.stringify({
    ...query,
    cmd: 'share',
    sharetype: 0,
    refresh: 'no'
  })

  // 跳转微信授权分发
  const miniprogramid = jsCookie('miniprogramid') || ''
  const uid = jsCookie.get('uid') || ''
  const skey = jsCookie.get('skey') || ''
  console.log(
    `is weixin: uid=${uid}, skey=${skey}, miniprogramid=${miniprogramid}`
  )

  const url = `https://ms.czj100.com/deal/confirmOrder?${queryStr}`
  const resUrl = `//app.czj100.com/webridge.html?url=${encodeURIComponent(
    url
  )}&uid=${uid}&skey=${skey}&miniprogramid=${miniprogramid}`

  return resUrl
}

export function goConfirm(spuId, query, useReplace = false) {
  App.$router[useReplace ? 'replace' : 'push']({
    name: 'product-confirm',
    params: {
      spuId
    },
    query: {
      ...query,
      cmd: 'share',
      sharetype: 0,
      refresh: 'no'
    }
  })
}
